// 2026-09-28 (Matt: variant case change): grind names may be 'Whole Bean' or 'whole bean'.
function isWholeBean(g) { return String(g || '').toLowerCase() === 'whole bean'; }
const SB_PLAN_FREQUENCIES = ['Every 2 weeks', 'Every 3 weeks', 'Every 4 weeks', 'Every 6 weeks', 'Quarterly'];
function sbPlanBaseName(frequency) { return frequency === 'Quarterly' ? 'Every 3 months' : frequency; }
function sbIsRecurringPlanName(name) { return SB_PLAN_FREQUENCIES.some((frequency) => sbPlanBaseName(frequency) === name); }
function sbResolvePlan(plans, frequency, payment, count) {
  if (payment !== 'Pay as you go' || !SB_PLAN_FREQUENCIES.includes(frequency)) return null;
  const name = sbPlanBaseName(frequency);
  return (plans || []).find((plan) => plan && plan.name === name) || null;
}
function sbNormalizePurchaseState(state) {
  if (state.payment !== 'Pay as you go') state.payment = 'Pay as you go';
  if (state.giftType !== 'monthly') state.giftType = 'monthly';
  delete state.prepaidCount;
  return state;
}
function sbPlanPriceCopy(priceCents) {
  return '$' + (Number(priceCents) / 100).toFixed(2) + ' per delivery';
}
function sbBuildPurchaseItem({ variant, plan, state, purchaseMode, wizardVariant }) {
  sbNormalizePurchaseState(state);
  if (!variant || !variant.available || (purchaseMode === 'subscription' && (!plan || !sbResolvePlan([plan], state.frequency, 'Pay as you go', 1)))) return null;
  const item = { id: variant.id, quantity: state.quantity, properties: {
    _preference: state.preference,
    _how_we_choose: state.mode === 'choice' ? "Roaster's Choice" : (state.mode === 'flavor' ? 'flavor profile' : 'country'),
    _wizard_variant: wizardVariant
  } };
  if (state.gift) Object.assign(item.properties, {
    _gift: 'true', 'Gift for': state.giftName, _gift_recipient_email: state.giftEmail,
    'Gift note': state.giftMessage, _gift_ship_date: state.giftShip,
    _gift_email_date: state.giftEmailDate, _gift_billing: 'ongoing'
  });
  if (purchaseMode === 'subscription') item.selling_plan = plan.id;
  return item;
}
function sbAvailableFrequencies(plans) {
  return SB_PLAN_FREQUENCIES.filter((frequency) => sbResolvePlan(plans, frequency, 'Pay as you go', 1));
}
if (typeof module !== 'undefined' && module.exports) module.exports = { SB_PLAN_FREQUENCIES, sbResolvePlan, sbAvailableFrequencies, sbNormalizePurchaseState, sbBuildPurchaseItem, sbPlanPriceCopy, sbIsRecurringPlanName };
(() => {
  if (typeof document === 'undefined') return;
  const root = document.getElementById('sbc-wizard');
  const cfgEl = document.getElementById('sbc-wizard-config');
  if (!root || !cfgEl || root.dataset.initialized) return;
  root.dataset.initialized = 'true';

  const cfg = JSON.parse(cfgEl.textContent);
  cfg.products = cfg.products || {};
  // Draft products are invisible to Liquid; the fallback asset is generated from
  // Shopify (which mirrors Thrive) so the preview still prices by bundle.
  if (!Object.keys(cfg.products).length && root.dataset.fallback) {
    fetch(root.dataset.fallback, { cache: 'no-store' })
      .then((r) => (r.ok ? r.json() : null))
      .then((data) => {
        if (data && data.products) {
          Object.keys(data.products).forEach((k) => { if (!cfg.products[k]) cfg.products[k] = data.products[k]; });
          presetFromHost();
          render();
        }
      })
      .catch(() => {});
  }
  // ---- Design (Matt, 2026-09-16) ----
  // The design is fixed by the template through the section's "design" setting
  // (product.subscription-a = A, product.subscription-b = B). No cookie, no
  // random bucket. ?ab=A|B still overrides for a quick preview of the other one.
  const forced = (new URLSearchParams(window.location.search).get('ab') || '').toUpperCase();
  let abVariant = forced === 'A' || forced === 'B' ? forced : (root.dataset.design || 'B').toUpperCase();
  if (abVariant !== 'A' && abVariant !== 'B') abVariant = 'B';
  root.dataset.variant = abVariant;
  root.classList.add('sb-wizard--' + abVariant.toLowerCase());
  const seenSteps = new Set();
  function track(name, extra) {
    const payload = Object.assign({ wizard_variant: abVariant, preference: state.preference, size: state.size, grind: state.grind, payment: state.payment, frequency: state.frequency }, extra || {});
    try { window.dataLayer = window.dataLayer || []; window.dataLayer.push(Object.assign({ event: name }, payload)); } catch (e) {}
    try { if (window.gtag) window.gtag('event', name, payload); } catch (e) {}
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(name, payload); } catch (e) {}
  }
  // Offered plans (Matt 2026-09-22 Q20): the section lists plan names in the order
  // customers see them; only those plans are offered. Other plans stay in Shopify
  // for existing subscribers and never render here.
  const offered = Array.isArray(cfg.offered) ? cfg.offered.map((n) => String(n).trim()).filter(Boolean) : [];
  const flavors = ['Bright & Fruity', 'Delicate & Dynamic', 'Smooth & Chocolatey'];
  const countries = ['Costa Rica', 'Colombia', 'Guatemala', 'Ethiopia'];
  const names = ['your coffee', 'bundle size', 'grind', 'delivery rhythm', 'review'];

  const state = {
    step: 0,
    mode: 'choice',
    preference: "Roaster's choice",
    size: 'Two 6-ounce bags', // Matt 2026-09-28: every choice starts on its leftmost option
    grind: 'Whole Bean',
    payment: 'Pay as you go',
    frequency: 'Every 4 weeks',
    giftType: 'monthly',
    quantity: 1,
    cups: '',
    gift: false,
    giftName: '',
    giftEmail: '',
    giftShip: '',
    giftEmailDate: '',
    giftMessage: ''
  };
  const purchaseMode = root.dataset.purchaseMode || 'subscription';
  const choiceScope = root.dataset.choiceScope || 'all';
  const incoming = new URLSearchParams(window.location.search);
  const allPreferences = ["Roaster's choice", ...flavors, ...countries];
  const allowedPreferences = choiceScope === 'flavor' ? flavors : choiceScope === 'country' ? countries : choiceScope === 'choice' ? ["Roaster's choice"] : allPreferences;
  const normalizePreference = (value) => String(value || '').toLowerCase().replace(/&/g, 'and').replace(/[^a-z0-9]/g, '');
  const requestedPreference = allPreferences.find((p) => normalizePreference(p) === normalizePreference(incoming.get('preference')));
  const requestedVariantId = incoming.get('variant');
  function presetFromHost() {
    const handle = (window.location.pathname.match(/\/products\/([^/?#]+)/) || [])[1];
    const hostEntries = Object.entries(cfg.products || {}).filter(([, p]) => p && p.handle === handle);
    const variantEntry = requestedVariantId ? Object.entries(cfg.products || {}).find(([, p]) => (p.variants || []).some((v) => String(v.id) === String(requestedVariantId))) : null;
    const entry = hostEntries.length === 1 ? hostEntries[0] : null;
    const matchedVariant = variantEntry && (variantEntry[1].variants || []).find((v) => String(v.id) === String(requestedVariantId));
    const pref = requestedPreference || (variantEntry && variantEntry[0]) || (entry && entry[0]) || root.dataset.defaultPreference || allowedPreferences[0];
    state.preference = allowedPreferences.includes(pref) ? pref : allowedPreferences[0];
    state.mode = flavors.includes(state.preference) ? 'flavor' : countries.includes(state.preference) ? 'country' : 'choice';
    if (matchedVariant) {
      if (ozOf(matchedVariant.size)) state.size = sizeState(ozOf(matchedVariant.size));
      if (matchedVariant.grind) state.grind = matchedVariant.grind;
    }
  }
  // Sizes (Matt 2026-09-25: 6oz, 12oz and 16oz on every combo pack, one time and subscription).
  // The sizes offered are the chosen bundle's own variant sizes, so a bundle shows 6oz as soon as
  // its 6oz variants exist and never offers a size it does not sell. Parsed as whole ounces, so
  // "6oz" never matches "16oz Bags", and "12oz Bag" (Delicate & Dynamic) matches "12oz Bags".
  function ozOf(label) {
    const m = /(\d+)\s*(?:-\s*ounce|oz)/i.exec(String(label || ''));
    return m ? Number(m[1]) : 0;
  }
  function sizeState(oz) { return 'Two ' + oz + '-ounce bags'; }
  function availableSizes() {
    const product = currentProduct();
    const found = Array.from(new Set(((product && product.variants) || []).map((v) => ozOf(v.size)).filter(Boolean))).sort((a, b) => a - b);
    return found.length ? found : [12, 16];
  }
  function ensureSize() {
    const sizes = availableSizes();
    if (sizes.indexOf(ozOf(state.size)) === -1) state.size = sizeState(sizes[0]); // leftmost (smallest) size
  }
  presetFromHost();
  if (ozOf(incoming.get('size'))) state.size = sizeState(ozOf(incoming.get('size')));
  if (['whole bean', 'coarse', 'medium', 'fine', 'extra fine'].includes(String(incoming.get('grind') || '').toLowerCase())) state.grind = incoming.get('grind');
  const requestedQuantity = Number(incoming.get('quantity'));
  if (Number.isSafeInteger(requestedQuantity) && requestedQuantity > 0) state.quantity = requestedQuantity;
  let reached = 0;
  let expanded = true;
  const completed = new Set();

  function money(cents) {
    return '$' + (Number(cents) / 100).toFixed(2);
  }

  function sizeKey() {
    return ozOf(state.size) + 'oz';
  }

  function currentProduct() {
    const products = cfg.products || {};
    return products[state.preference] || null;
  }

  // Sold out (2026-09-25): a pack with no variant for sale (Ethiopia until Jonathan picks its
  // coffees) is disabled in the preference lists, and the add button reads the theme's own
  // "sold out" label, disabled. Nothing is added to the cart.
  const soldOutLabel = (root.dataset.soldOut || 'Sold Out').toLowerCase();
  function packAvailable(pref) {
    const p = (cfg.products || {})[pref];
    return !!(p && (p.variants || []).some((v) => v.available));
  }
  function currentVariant() {
    const wantOz = ozOf(state.size);
    const product = currentProduct();
    return ((product && product.variants) || []).find((v) => {
      const grind = (v.grind || '').toLowerCase();
      const sizeOk = ozOf(v.size) === wantOz;
      const grindOk = grind === state.grind.toLowerCase();
      return sizeOk && grindOk;
    }) || null;
  }

  function offeredPlans() {
    const product = currentProduct();
    const plans = (product && product.plans) || [];
    const recurringPlans = plans.filter((plan) => plan && sbIsRecurringPlanName(plan.name));
    if (!offered.length) return recurringPlans;
    return offered.filter(sbIsRecurringPlanName).map((name) => recurringPlans.find((p) => p.name === name)).filter(Boolean);
  }

  function shipmentCount(plan) {
    const m = String((plan && plan.name) || '').match(/(\d+)\s+shipments?/i);
    return m ? Number(m[1]) : 1;
  }

  // Cups-a-day recommendation (Matt 2026-09-22 Q15): 30 g per cup, 2 bags per
  // bundle, 6 oz = 170 g, 12 oz = 340 g, 16 oz = 454 g. Picks the longest offered pay-per-delivery
  // rhythm that does not run out before the next delivery.
  function rhythmDays(name) {
    const n = String(name || '').toLowerCase();
    let m = n.match(/every (\d+) weeks?/); if (m) return Number(m[1]) * 7;
    m = n.match(/every (\d+) months?/); if (m) return Number(m[1]) * 30;
    if (/every (a )?month/.test(n)) return 30;
    if (/every (a )?week/.test(n)) return 7;
    return 0;
  }
  function cupsPerDelivery() {
    const oz = ozOf(state.size);
    const grams = { 6: 170, 12: 340, 16: 454 }[oz] || Math.round(oz * 28.3495);
    return Math.floor((2 * grams) / 30);
  }
  function cupsValue() { return state.cups === 'not sure' ? 0 : parseInt(state.cups, 10) || 0; }
  function recommendedPlan(cupsPerDay) {
    if (!cupsPerDay) return null;
    const lasts = cupsPerDelivery() / cupsPerDay;
    const regular = offeredPlans().filter((p) => shipmentCount(p) === 1 && rhythmDays(p.name));
    const fits = regular.filter((p) => rhythmDays(p.name) <= lasts).sort((a, b) => rhythmDays(b.name) - rhythmDays(a.name));
    if (fits.length) return { plan: fits[0], short: false };
    const shortest = regular.slice().sort((a, b) => rhythmDays(a.name) - rhythmDays(b.name))[0];
    return shortest ? { plan: shortest, short: true } : null;
  }
  function cupsNote() {
    if (state.cups === 'not sure') {
      const monthly = offeredPlans().find((p) => shipmentCount(p) === 1 && rhythmDays(p.name) === 30);
      return monthly ? 'most of our subscribers get a bundle about once a month, so ' + monthly.name.toLowerCase() + ' is a good start. you can change it any time.' : '';
    }
    const cups = cupsValue();
    if (!cups) return '';
    const rec = recommendedPlan(cups);
    if (!rec) return '';
    const bags = 'two ' + sizeKey() + ' bags';
    const base = bags + ' make about ' + cupsPerDelivery() + ' cups. at ' + (cups >= 4 ? '4 or more cups' : cups + (cups > 1 ? ' cups' : ' cup')) + ' a day, ' + rec.plan.name.toLowerCase() + ' fits';
    if (rec.short) {
      return bags + ' make about ' + cupsPerDelivery() + ' cups, about ' + Math.floor(cupsPerDelivery() / cups) + ' days at ' + (cups >= 4 ? '4 or more cups' : cups + ' cups') + ' a day. our shortest rhythm is ' + rec.plan.name.toLowerCase() + ', so 16oz bags will last longer.';
    }
    return base + '.';
  }
  function giftNoteDate(iso) {
    const m = String(iso || '').match(/^(\d{4})-(\d{2})-(\d{2})$/);
    if (!m) return String(iso || '');
    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    return months[Number(m[2]) - 1] + ' ' + Number(m[3]) + ', ' + m[1];
  }
  function giftReady() {
    if (!state.gift) return true;
    return state.giftName && /.+@.+\..+/.test(state.giftEmail) && state.giftShip && state.giftEmailDate;
  }

  // Gift date validation (Matt, W4-25, 2026-09-23): the date pickers set
  // min=today, but a typed date bypasses that, so it is checked again here
  // on add to cart. Plain sentence, no add to cart when a date is bad. No ordering rule between
  // the two dates (Matt's mock: first delivery Dec 19, gift email Dec 25; declined 2026-09-22).
  function todayISO() {
    return new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().slice(0, 10);
  }
  function giftDateProblem() {
    if (!state.gift) return '';
    var today = todayISO();
    if (state.giftShip && state.giftShip < today) return 'The first delivery date cannot be before today.';
    if (state.giftEmailDate && state.giftEmailDate < today) return 'The gift email date cannot be before today.';
    return '';
  }

  function currentPlan() {
    sbNormalizePurchaseState(state);
    const product = currentProduct();
    const plans = (product && product.plans) || [];
    return sbResolvePlan(plans, state.frequency, 'Pay as you go', 1);
  }

  function priceCopy() {
    const variant = currentVariant();
    if (!variant) return '';
    const plan = currentPlan();
    if (purchaseMode === 'subscription' && !plan) return 'Delivery plan unavailable for this rhythm.';
    return sbPlanPriceCopy(variant.priceCents);
  }

  function option(name, value, label, description) {
    const checked = state[name] === value ? ' checked' : '';
    const off = name === 'preference' && !packAvailable(value) ? ' disabled' : '';
    const desc = description ? '<small>' + description + '</small>' : '';
    return '<label class="sb-guided-choice"><input type="radio" name="' + name + '" value="' + value + '"' + checked + off + '><span class="label-swatch"><span>' + label + desc + '</span></span></label>';
  }

  function deliverySummary() {
    if (state.gift) return 'Gift · ' + state.frequency + ' subscription';
    return state.payment + ' · ' + state.frequency;
  }

  let render = function render() {
    sbNormalizePurchaseState(state);
    ensureSize();
    const focused = document.activeElement;
    const focusName = focused && focused.name;
    const focusValue = focused && focused.value;
    const focusWhole = focused && focused.hasAttribute('data-whole-bean');
    const active = root.querySelector('#sbc-active');
    const decisions = root.querySelector('#sbc-decisions');
    decisions.parentElement.append(active);

    const summaries = [state.preference, state.size, state.grind, deliverySummary(), 'Your selections'];
    decisions.innerHTML = names.map((name, i) => {
      const open = state.step === i && expanded;
      const mark = open ? '−' : (completed.has(i) ? 'edit' : '+');
      const small = completed.has(i) ? '<small>' + summaries[i] + '</small>' : '';
      const disabled = i > reached ? ' disabled' : '';
      return '<section class="decision"><button type="button" class="decision-heading" data-open="' + i + '" aria-expanded="' + open + '" aria-controls="sbc-decision-' + i + '"' + disabled + '><span>' + String(i + 1).padStart(2, '0') + ' · ' + name + small + '</span><span aria-hidden="true">' + mark + '</span></button><div id="sbc-decision-' + i + '"></div></section>';
    }).join('');

    root.querySelector('#sbc-decision-' + state.step).append(active);
    active.hidden = !expanded;
    root.querySelector('#sbc-step-label').textContent = String(state.step + 1).padStart(2, '0') + ' / 05 · ' + names[state.step];
    if (!seenSteps.has(state.step)) { seenSteps.add(state.step); track('sb_wizard_step', { step: state.step + 1, step_name: names[state.step] }); }

    const panel = root.querySelector('#sbc-step');
    if (state.step === 0) {
      panel.innerHTML = '<fieldset><legend>how should we choose?</legend><div class="choices">' +
        option('mode', 'choice', "Roaster's choice", 'No preference. Let our roasters pick your coffees.') +
        option('mode', 'flavor', 'Pick by flavor profile', 'Choose the kind of cup you enjoy.') +
        option('mode', 'country', 'Pick by country', 'Keep your coffee rooted in a favorite origin.') +
        '</div></fieldset><div id="sbc-preferences" style="margin-top:24px"></div>';
      const list = state.mode === 'flavor' ? flavors : state.mode === 'country' ? countries : [];
      if (list.length) {
        const legend = state.mode === 'flavor' ? 'your flavor profile' : 'your country';
        root.querySelector('#sbc-preferences').innerHTML = '<fieldset><legend>' + legend + '</legend><div class="choices">' + list.map((v) => option('preference', v, v)).join('') + '</div></fieldset>';
      }
    } else if (state.step === 1) {
      panel.innerHTML = '<fieldset><legend>choose your bag size</legend><div class="choices">' +
        availableSizes().map((oz) => option('size', sizeState(oz), 'Two ' + oz + '-ounce bags', 'Two different coffees, one ' + oz + '-ounce bag of each.')).join('') +
        '</div></fieldset>';
    } else if (state.step === 2) {
      const whole = isWholeBean(state.grind);
      panel.innerHTML = '<fieldset><legend>whole bean or ground?</legend><div class="sb-jpdp-grind"><button type="button" class="sb-jpdp-grind-pill' + (whole ? ' is-selected' : '') + '" data-whole-bean aria-pressed="' + whole + '">Whole Bean</button><span class="sb-jpdp-grind-selectwrap' + (whole ? '' : ' is-selected') + '"><select name="grind" aria-label="Ground coffee grind level" class="sb-jpdp-grind-select' + (whole ? '' : ' is-selected') + '"><option value=""' + (whole ? ' selected' : '') + '>Ground</option>' +
        ['Coarse', 'Medium', 'Fine', 'Extra Fine'].map((v) => '<option value="' + v + '"' + (state.grind === v ? ' selected' : '') + '>' + v + '</option>').join('') +
        '</select></span></div></fieldset>';
    } else if (state.step === 3) {
      const product = currentProduct();
      const plans = (product && product.plans) || [];
      const frequencies = sbAvailableFrequencies(plans);
      const rhythm = '<div class="choices">' + frequencies.map((frequency) => option('frequency', frequency, frequency === 'Quarterly' ? 'Quarterly' : frequency)).join('') + '</div>';
      panel.innerHTML = '<fieldset><legend>how often?</legend>' + rhythm + '</fieldset><fieldset style="margin-top:28px"><legend>how would you like to pay?</legend><div class="choices">' +
        option('payment', 'Pay as you go', 'Pay as you go', 'Pay for each delivery as it ships.') +
        '</div></fieldset>';
    } else {
      const rows = [
        ['Coffee', state.preference, 0],
        ['Bundle', state.size, 1],
        ['Grind', state.grind, 2],
        ['Payment', state.payment, 3],
        ['Delivery', deliverySummary(), 3]
      ];
      panel.innerHTML = '<h2>make it yours</h2>' + rows.map(([label, value, n]) =>
        '<div class="review-line"><span><small>' + label + '</small>' + value + '</span><button type="button" data-edit="' + n + '">edit</button></div>'
      ).join('') + '<p class="review-note" style="margin-top:24px">' + priceCopy() + '.</p>';
    }

    const summaryRows = [
      ['Coffee', state.preference, 0],
      ['Bundle', state.size, 1],
      ['Grind', state.grind, 2],
      ['Payment', state.payment, 3],
      ['Delivery', deliverySummary(), 3]
    ];
    root.querySelector('#sbc-summary').innerHTML = summaryRows.map(([a, b, i]) =>
      '<dt>' + a + '</dt><dd>' + (completed.has(i) || state.step === i ? b : 'To choose') + '</dd>'
    ).join('');
    const priceEl = root.querySelector('#sbc-price');
    if (priceEl) priceEl.textContent = priceCopy();

    root.querySelector('#sbc-back').disabled = state.step === 0;
    const next = root.querySelector('#sbc-next');
    const unavailablePlan = state.step === 4 && purchaseMode === 'subscription' && !currentPlan();
    next.disabled = unavailablePlan;
    next.textContent = unavailablePlan ? 'unavailable' : (state.step === 4 ? 'add subscription →' : 'continue →');

    if (focusWhole) root.querySelector('[data-whole-bean]')?.focus();
    else if (focusName) Array.from(root.querySelectorAll('input,select')).find((el) => el.name === focusName && el.value === focusValue)?.focus();
  }

  async function addSubscription() {
    sbNormalizePurchaseState(state);
    const variant = currentVariant();
    const plan = currentPlan();
    const status = root.querySelector('#sbc-b-status') || root.querySelector('#sbc-review-status');
    const next = root.querySelector('#sbc-b-add') || root.querySelector('#sbc-next');
    if (next.disabled) return;
    const buttonLabel = next.textContent;
    if (state.gift && !giftReady()) {
      status.textContent = 'Add their name, email, the first delivery date and the gift email date.';
      return;
    }
    if (state.gift) {
      var giftProblem = giftDateProblem();
      if (giftProblem) {
        status.textContent = giftProblem;
        return;
      }
    }
    if (variant && !variant.available) return;
    if (!variant || (purchaseMode === 'subscription' && !plan)) {
      status.textContent = variant ? 'Delivery plans for this bundle are not set up yet.' : 'This combination is not available. Edit size, grind, or delivery and try again.';
      return;
    }
    next.disabled = true;
    next.textContent = 'adding…';
    status.textContent = '';
    try {
      track('sb_wizard_add', { variant_id: variant.id, plan_id: plan && plan.id, price_cents: variant.priceCents });
      const cartUpdate = { attributes: { _wizard_variant: root.dataset.variant } };
      if (state.gift) {
        // Matt 2026-09-22 (gift first delivery): the order carries the note
        // "Gift subscription, ship on Mon D, YYYY" first, then any note the
        // customer typed, so ShipStation shows it and the team holds the order.
        const giftLine = 'Gift subscription, ship on ' + giftNoteDate(state.giftShip);
        const current = await fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json()).catch(() => ({}));
        const rest = String((current && current.note) || '').split('\n').filter((l) => l.indexOf('Gift subscription, ship on ') !== 0).join('\n').trim();
        cartUpdate.note = rest ? giftLine + '\n' + rest : giftLine;
      }
      await fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(cartUpdate) }).catch(() => {});
      // G-14 (2026-09-24): these are for our records only. The bundle product already names the
      // preference and the line carries its own quantity, so they are hidden (leading underscore)
      // instead of printing on checkout, the order and ShipStation. Nothing downstream reads them.
      const item = sbBuildPurchaseItem({ variant, plan, state, purchaseMode, wizardVariant: root.dataset.variant });
      if (!item) throw new Error('This purchase option is unavailable. Review your selections and try again.');
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [item]
        })
      });
      if (!res.ok) {
        const err = await res.json().catch(() => ({}));
        throw new Error(err.description || err.message || 'Could not add to cart');
      }
      window.location.href = '/cart';
    } catch (err) {
      status.textContent = err.message || 'Could not add to cart.';
      next.disabled = false;
      next.textContent = buttonLabel;
    }
  }

  root.addEventListener('change', (e) => {
    if (e.target.matches('select[name=grind]')) {
      state.grind = e.target.value || 'Whole Bean';
      render();
      return;
    }
    if (!e.target.matches('input[type=radio]')) return;
    state[e.target.name] = e.target.value;
    if (e.target.name === 'mode') {
      state.preference = state.mode === 'choice' ? "Roaster's choice" : (state.mode === 'flavor' ? flavors[0] : countries[0]);
    }
    render();
  });

  root.querySelector('#sbc-next').addEventListener('click', () => {
    if (state.step < 4) {
      completed.add(state.step);
      state.step += 1;
      reached = Math.max(reached, state.step);
      expanded = true;
      render();
      root.querySelector('[data-open="' + state.step + '"]').focus();
      return;
    }
    addSubscription();
  });

  root.querySelector('#sbc-back').addEventListener('click', () => {
    if (!state.step) return;
    state.step -= 1;
    render();
    root.querySelector('[data-open="' + state.step + '"]').focus();
  });

  root.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-open]');
    if (opener) {
      const n = Number(opener.dataset.open);
      expanded = n === state.step ? !expanded : true;
      state.step = n;
      render();
      root.querySelector('[data-open="' + n + '"]').focus();
      return;
    }
    if (e.target.closest('[data-whole-bean]')) {
      state.grind = 'Whole Bean';
      render();
      return;
    }
    const edit = e.target.closest('[data-edit]');
    if (edit) {
      state.step = Number(edit.dataset.edit);
      expanded = true;
      render();
      root.querySelector('[data-open="' + state.step + '"]').focus();
    }
  });

  // ---- Design B (Jonathan, 2026-09-15): one panel, every choice visible ----
  // Same state, same products, same add-to-cart; only the presentation differs.
  function renderB() {
    // Design B = the product page's own structure: .sb-jpdp-buybox__grid with
    // the bag field on the left and the buy box on the right, the JPDP name
    // token for the title, the grind pill/select components for every control.
    ensureSize();
    const ds = root.dataset;
    let panel = root.querySelector('#sbc-b');
    if (!panel) {
      const content = root.querySelector('.sb-guided-content');
      content.querySelectorAll(':scope > *').forEach((el) => { if (el.id !== 'sbc-wizard-config') el.hidden = true; });
      panel = document.createElement('div');
      panel.id = 'sbc-b';
      content.appendChild(panel);
    }
    const product = currentProduct();
    const plans = (product && product.plans) || [];
    const variant = currentVariant();
    const priceNow = variant && currentPlan() ? money(variant.priceCents * shipmentCount(currentPlan()) * state.quantity) : '';
    const pill = (name, value, label, disabled) => '<button type="button" class="sb-jpdp-grind-pill' + (state[name] === value && !disabled ? ' is-selected' : '') + '" data-set="' + name + '" data-value="' + value + '" aria-pressed="' + (state[name] === value && !disabled) + '"' + (disabled ? ' disabled aria-disabled="true"' : '') + '>' + label + '</button>';
    const prefLists = { 'b-flavor': 1, 'b-country': 1 };
    const sel = (name, options, placeholder, current) => '<span class="sb-jpdp-grind-selectwrap' + (current ? ' is-selected' : '') + '"><select name="' + name + '" aria-label="' + placeholder + '" class="sb-jpdp-grind-select' + (current ? ' is-selected' : '') + '"><option value="">' + placeholder + '</option>' +
      options.map((o) => '<option value="' + o + '"' + (current === o ? ' selected' : '') + (prefLists[name] && !packAvailable(o) ? ' disabled' : '') + '>' + o.toLowerCase() + '</option>').join('') + '</select></span>';
    const plan = currentPlan();
    const soldOut = !variant || !variant.available || (purchaseMode === 'subscription' && !plan);
    const freqOptions = sbAvailableFrequencies(plans);
    const showFlavor = choiceScope === 'all' || choiceScope === 'flavor';
    const showCountry = choiceScope === 'all' || choiceScope === 'country';
    const showChoice = choiceScope === 'all' || choiceScope === 'choice';
    const freqCurrent = state.frequency;
    const subscriptionParams = new URLSearchParams({ preference: state.preference, size: sizeKey(), grind: state.grind, quantity: String(state.quantity) });
    const subscriptionLink = purchaseMode === 'one_time' ? '<p class="sb-jpdp-note"><a id="sbc-b-subscribe" href="' + (ds.subscriptionUrl || '/products/coffee-subscription') + '?' + subscriptionParams.toString() + '">prefer a recurring delivery?</a></p>' : '';
    panel.innerHTML =
      '<div class="sb-jpdp-buybox__grid">' +
        '<div class="sb-jpdp-bagfield' + (ds.bImage ? '' : ' sb-jpdp-bagfield--empty') + '">' + (ds.bImage ? '<img src="' + ds.bImage + '" alt="" loading="eager">' : '') + '</div>' +
        '<div>' +
          '<h1 class="sb-jpdp-name sb-jpdp-name--nodot">' + ds.bHeading + '</h1>' +
          (ds.bLead ? '<p class="sb-jpdp-lead">' + ds.bLead + '</p>' : '') +
          '<div class="sb-jpdp-buybox__form">' +
            '<div class="sb-jpdp-grind sb-jpdp-grind--3">' + availableSizes().map((oz) => pill('size', sizeState(oz), 'two ' + oz + 'oz bags')).join('') + '</div>' +
            '<div class="sb-jpdp-grind sb-jpdp-grind--3">' + (showChoice ? pill('mode', 'choice', "roaster's choice") : '') +
              (showFlavor ? sel('b-flavor', flavors, 'by flavor profile', state.mode === 'flavor' ? state.preference : '') : '') +
              (showCountry ? sel('b-country', countries, 'by country', state.mode === 'country' ? state.preference : '') : '') + '</div>' +
            '<div class="sb-jpdp-grind sb-jpdp-grind--3 sb-jpdp-grind--tail2">' + pill('grind', 'Whole Bean', 'whole bean') +
              sel('b-grind', ['Coarse', 'Medium', 'Fine', 'Extra Fine'], 'ground', !isWholeBean(state.grind) ? state.grind : '') + '</div>' +
            /* Matt 2026-09-28: "cups a day" removed from the page. */
            '<div class="sb-jpdp-grind sb-jpdp-grind--3 sb-jpdp-grind--tail2">' + (purchaseMode === 'subscription' ? sel('b-frequency', freqOptions, 'frequency', freqCurrent) : '<input class="sb-jpdp-grind-select" type="number" min="1" step="1" value="' + state.quantity + '" aria-label="quantity" data-quantity>') +
            (purchaseMode === 'subscription' && !state.gift ? '<div class="sb-jpdp-grind">' + pill('payment', 'Pay as you go', 'pay per delivery') + '</div>' : '') +
              '<button type="button" class="sb-jpdp-grind-pill is-selected sb-jpdp-grind-pill--go" id="sbc-b-add"' + (soldOut ? ' disabled aria-disabled="true"' : '') + '>' + (soldOut ? (!variant || !variant.available ? soldOutLabel : 'unavailable') : 'add ' + (state.quantity > 1 ? state.quantity + ' bundles ' : '') + 'to cart · ' + priceNow) + '</button></div>' +
          '</div>' +
          (purchaseMode === 'subscription' ? '<p class="sb-jpdp-note">' + priceCopy() + '</p>' : '') +
          (purchaseMode === 'subscription' ? giftBlock() : '') +
          (ds.bPlansNote && purchaseMode === 'subscription' ? '<p class="sb-jpdp-note">' + ds.bPlansNote + '</p>' : '') +
          (ds.bGift ? '<p class="sb-jpdp-note">' + ds.bGift + '</p>' : '') +
          subscriptionLink +
          '<p id="sbc-b-status" class="review-note" aria-live="polite"></p>' +
        '</div>' +
      '</div>' +
      (ds.bStoryHeading ? '<section class="sb-jpdp-story--plain"><h2 class="sb-jpdp-name sb-jpdp-name--nodot">' + ds.bStoryHeading + '</h2><div>' + ds.bStory.split(/\n\s*\n/).map((p) => '<p>' + p + '</p>').join('') + '</div></section>' : '');
  }
  function giftBlock() {
    const field = (key, type, label) => '<input class="sb-jpdp-grind-select" type="' + type + '" data-gift="' + key + '" aria-label="' + label + '" placeholder="' + label + '" value="' + String(state[key] || '').replace(/"/g, '&quot;') + '">';
    const today = new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().slice(0, 10);
    const dated = (key, label) => '<label class="sb-jpdp-field">' + label + field(key, 'date', label).replace('<input ', '<input min="' + today + '" ') + '</label>';
    const yes = '<button type="button" class="sb-jpdp-grind-pill' + (state.gift ? ' is-selected' : '') + '" data-gift-toggle="1" aria-pressed="' + state.gift + '">this is a gift</button>';
    if (!state.gift) return '<div class="sb-jpdp-grind sb-jpdp-grind--3">' + yes + '</div>';
    const giftPlans = (currentProduct() && currentProduct().plans) || [];
    const recurringPlan = sbResolvePlan(giftPlans, state.frequency, 'Pay as you go', 1);
    const billing = 'you are charged each delivery at your selected frequency until you stop it.';
    return '<div class="sb-jpdp-buybox__form sb-jpdp-gift"><div class="sb-jpdp-grind sb-jpdp-grind--3">' + yes + '</div>' +
      '<fieldset><legend>gift subscription</legend><div class="sb-jpdp-grind sb-jpdp-grind--3">' +
        '<button type="button" class="sb-jpdp-grind-pill is-selected" data-gift-type="monthly" aria-pressed="true"' + (!recurringPlan ? ' disabled aria-disabled="true"' : '') + '>pay per delivery</button>' +
      '</div></fieldset>' +
      '<div class="sb-jpdp-grind sb-jpdp-grind--3 sb-jpdp-grind--tail2">' + field('giftName', 'text', 'their name') + field('giftEmail', 'email', 'their email') + '</div>' +
      '<div class="sb-jpdp-grind sb-jpdp-grind--3 sb-jpdp-grind--tail2">' + dated('giftShip', 'first delivery ships') + dated('giftEmailDate', 'gift email arrives') + '</div>' +
      '<div class="sb-jpdp-grind sb-jpdp-grind--full">' + field('giftMessage', 'text', 'a note for the gift email') + '</div>' +
      '<p class="sb-jpdp-note">' + billing + ' you enter their shipping address at checkout.</p></div>';
  }
  if (root.dataset.variant === 'B') {
    const origRender = render;
    render = function () { renderB(); };
    root.classList.add('sb-jpdp-block');
    root.style.setProperty('--sb-jpdp-origin', '#C75D31');
    root.addEventListener('click', (e) => {
      const b = e.target.closest('.sb-jpdp-grind-pill[data-set]');
      if (!b) return;
      state[b.dataset.set] = b.dataset.value;
      if (b.dataset.set === 'mode') state.preference = "Roaster's choice";
      render();
    });
    root.addEventListener('click', (e) => {
      const t = e.target.closest('[data-gift-toggle]');
      if (t) { state.gift = !state.gift; render(); return; }
      const giftType = e.target.closest('[data-gift-type]');
      if (giftType) { if (giftType.dataset.giftType !== 'monthly') return; state.giftType = 'monthly'; render(); return; }
      return;
    });
    root.addEventListener('input', (e) => {
      const k = e.target.dataset && e.target.dataset.gift;
      if (k) state[k] = e.target.value;
    });
    root.addEventListener('input', (e) => {
      if (!e.target.matches('[data-quantity]')) return;
      const quantity = Number(e.target.value);
      if (!Number.isSafeInteger(quantity) || quantity < 1) return;
      state.quantity = quantity;
      const link = root.querySelector('#sbc-b-subscribe');
      if (link) {
        const params = new URLSearchParams({ preference: state.preference, size: sizeKey(), grind: state.grind, quantity: String(state.quantity) });
        link.href = (root.dataset.subscriptionUrl || '/products/coffee-subscription') + '?' + params.toString();
      }
    });
    root.addEventListener('change', (e) => {
      const n = e.target.name;
      if (n === 'b-flavor' && e.target.value) { state.mode = 'flavor'; state.preference = e.target.value; render(); }
      if (n === 'b-country' && e.target.value) { state.mode = 'country'; state.preference = e.target.value; render(); }
      if (n === 'b-grind') { state.grind = e.target.value || 'Whole Bean'; render(); }
      if (e.target.matches('[data-quantity]')) { state.quantity = Math.max(1, Math.floor(Number(e.target.value) || 1)); render(); }
      if (n === 'b-cups') {
        state.cups = e.target.value;
        const rec = state.cups === 'not sure'
          ? { plan: offeredPlans().find((p) => shipmentCount(p) === 1 && rhythmDays(p.name) === 30) }
          : recommendedPlan(cupsValue());
        if (rec && rec.plan && shipmentCount(currentPlan()) === 1) { state.frequency = rec.plan.name; state.payment = 'Pay as you go'; }
        render();
        return;
      }
      if (n === 'b-frequency') {
        if (e.target.value) state.frequency = e.target.value;
        render();
      }
    });
    root.addEventListener('click', (e) => {
      if (!e.target.closest('#sbc-b-add')) return;
      addSubscription();
    });
    void origRender;
  }

  render();
})();
